/**
 * Cartões de detalhe nas regiões do AppShell (§7.1 "Prioridade do cartão", §4.4.2, §8; FE §5): coluna direita do
 * desktop com foco (dentro da boundary `place-card` do AppShell) e cartão principal do tablet, do `land` e do `flow`
 * com foco (região `card`, a mesma boundary).
 *
 * Os cartões ficam no chunk `index` (§15.7.1 B07: "`places` se separado"): separados, o `IconButton` que eles dividem
 * com os chunks `about` e `probability` vira um chunk comum, e o Rolldown tira o núcleo do `index` (Preact, sinais,
 * estado) para um chunk `hooks-*.js` fora do B01 (DE-C20, o mesmo caso do `theme/ink.ts` da Fase 5). No `index`, o
 * cartão também existe no mesmo quadro da rota, e o foco do roteador (§5.9) sempre acha o `#place-title`.
 *
 * Prioridade (§7.1): `CandidateProfileCard` > cartão do lugar da rota. CASCA: Fase 7b — o perfil e os cartões de
 * Exterior, país e cidade entram com a Fase 7b; até lá montam o `UfCard` e o `MunicipalityCard` (§8.4) (com o perfil aberto sobre uma UF,
 * o cartão da UF continua no lugar, para a coluna nunca ficar vazia).
 */
import { AbroadCard } from '../features/places/AbroadCard';
import { AbroadCityCard } from '../features/places/AbroadCityCard';
import { CountryCard } from '../features/places/CountryCard';
import { MunicipalityCard } from '../features/places/MunicipalityCard';
import { UfCard } from '../features/places/UfCard';
import { useHasFocus, useRouteState } from '../state/hooks';
import { GovernorChance } from './governorChance';
import { MunicipalityInsightsSlot } from './insightsSlot';
import { munMesh } from './munMeshState';

/** O cartão do foco: a UF, o município (Fase 7b, §8.4) e o Exterior, o país e a cidade (Fase 8, §8.5). */
export function PlaceSlot() {
  const route = useRouteState();
  const hasFocus = useHasFocus();
  if (!hasFocus) return null;
  if (route.place.kind === 'municipality') return <MunicipalityCard insights={<MunicipalityInsightsSlot />} />;
  // Fase 8 (§8.5): o Exterior, o país e a cidade do exterior
  if (route.place.kind === 'abroad') return <AbroadCard />;
  if (route.place.kind === 'country') return <CountryCard />;
  if (route.place.kind === 'abroad_city') return <AbroadCityCard />;
  if (route.place.kind !== 'uf') return null;
  // dica "Clique num município" (AC-8.2-07): só com a malha municipal da UF desenhada (Fase 10, features/map/munBinding.ts)
  const mesh = munMesh.value;
  return (
    <UfCard
      municipalMap={mesh !== null && mesh.uf === route.place.uf && mesh.status === 'ready'}
      governorChance={(uf) => <GovernorChance uf={uf} />}
    />
  );
}
